import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "content-shape container condensed pt-4"
};
var _hoisted_2 = {
  class: "d-flex flex-row align-items-center mb-4"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Notifications");

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" Mark as read ");

import { reactive } from "vue";
import { useLoadingBar, useMessage } from "naive-ui";
import { CheckmarkDone } from "@vicons/ionicons5";
import { useUserStore } from "@/store/user";
import { LoaderState } from "@/types/generic";
import { handleError } from "@/utils/errors";
import { silentRead } from "@/utils/notifications";
import NotificationList from "@/components/notifications/NotificationList.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var loadingBar = useLoadingBar();
    var messageAPI = useMessage();
    var userStore = useUserStore();
    var loaders = reactive({
      fetch: LoaderState.Idle
    });
    var errors = reactive({});

    var load = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$http$get, notifications;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loadingBar.start();

                if (userStore.notifications.length === 0) {
                  loaders.fetch = LoaderState.Loading;
                }

                _context.prev = 2;
                _context.next = 5;
                return http.get("/users/notifications");

              case 5:
                _yield$http$get = _context.sent;
                notifications = _yield$http$get.data;
                userStore.notifications = notifications;
                loaders.fetch = LoaderState.Loaded;
                loadingBar.finish();
                _context.next = 20;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);
                _context.next = 16;
                return handleError(_context.t0, {
                  placeholder: "We could not refresh your notifications, this list may be oudated"
                });

              case 16:
                errors.fetch = _context.sent;
                messageAPI.warning(errors.fetch, {
                  closable: true,
                  duration: 0
                });
                loaders.fetch = LoaderState.Idle;
                loadingBar.error();

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 12]]);
      }));

      return function load() {
        return _ref.apply(this, arguments);
      };
    }();

    var markAsRead = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var notifications;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                notifications = userStore.unreadNotifications;
                silentRead(notifications.map(function (n) {
                  return n.userNotificationId;
                }));
                notifications.forEach(function (n) {
                  return n.status = true;
                });
                messageAPI.success("All notifications have been marked as read");

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function markAsRead() {
        return _ref2.apply(this, arguments);
      };
    }();

    load();
    return function (_ctx, _cache) {
      var _component_n_h1 = _resolveComponent("n-h1");

      var _component_n_icon = _resolveComponent("n-icon");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_tab_pane = _resolveComponent("n-tab-pane");

      var _component_n_tabs = _resolveComponent("n-tabs");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createVNode(_component_n_h1, {
        class: "mb-0 flex-fill"
      }, {
        default: _withCtx(function () {
          return [_hoisted_3];
        }),
        _: 1
      }), _unref(userStore).hasUnreadNotification ? (_openBlock(), _createBlock(_component_n_button, {
        key: 0,
        secondary: "",
        type: "info",
        onClick: markAsRead
      }, {
        icon: _withCtx(function () {
          return [_createVNode(_component_n_icon, null, {
            default: _withCtx(function () {
              return [_createVNode(_unref(CheckmarkDone))];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_hoisted_4];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_n_tabs, {
        type: "line"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_tab_pane, {
            name: "unread",
            tab: "Unread ".concat(_unref(userStore).hasUnreadNotification ? "(".concat(_unref(userStore).unreadNotifications.length, ")") : '')
          }, {
            default: _withCtx(function () {
              return [_createVNode(NotificationList, {
                notifications: _unref(userStore).unreadNotifications,
                loader: _unref(loaders).fetch,
                error: _unref(errors).fetch,
                empty: "You don't have any new notifications.",
                onRetry: _cache[0] || (_cache[0] = function ($event) {
                  return load();
                })
              }, null, 8, ["notifications", "loader", "error"])];
            }),
            _: 1
          }, 8, ["tab"]), _createVNode(_component_n_tab_pane, {
            name: "read",
            tab: "Previous notifications"
          }, {
            default: _withCtx(function () {
              return [_createVNode(NotificationList, {
                notifications: _unref(userStore).readNotifications,
                loader: _unref(loaders).fetch,
                error: _unref(errors).fetch,
                onRetry: _cache[1] || (_cache[1] = function ($event) {
                  return load();
                })
              }, null, 8, ["notifications", "loader", "error"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })]);
    };
  }
});